// extracted by mini-css-extract-plugin
export default {"loader-style":"styles_loader-style__tgLtk"};